/** Acupoint strike (fx 'seal'): a sharp cyan star on the target. */
import { registerFx } from './registry';

registerFx('seal', (host) => ({
  skill: ({ src, tgt, tx, ty }) => {
    if (tgt) {
      host.fx.push({
        type: 'star',
        x: tx,
        y: ty - 16 * host.tall(tgt),
        t: 0,
        life: 0.35,
        r: 14,
        col: '140,230,255',
      });
      host.fx.push({ type: 'ring', x: tx, y: ty, t: 0, life: 0.5, r: 14, col: '140,230,255' });
    }
    host.swingArc(src, 'thrust', '140,230,255');
    host.sfx.interrupt();
  },
}));
